/* eslint-disable @reatom/unit-naming-rule */
import { withAssign } from '@reatom/framework'

import { EXPLORE_LIST_PERIOD_MAP } from '../model/constants'
import { ExploreFeedType } from '../model/explore-feed-type'

import { reatomExploreFiltersForm } from './reatom-explore-filters-form'
import { reatomExploreFiltersState } from './reatom-explore-filters-state'

import type { ExploreFilter } from '../model'
import type { PairMetrics } from '@root/entities/pair'

export type ExploreFiltersState = ExploreFilter.ExploreFilter

export const reatomExploreFilters = ({
  name,
  period,
}: {
  name: string
  period: PairMetrics.MetricsSpan | undefined
}) => {
  const stateModel = reatomExploreFiltersState(name)
  const formModel = reatomExploreFiltersForm({ state: stateModel }, name)

  return stateModel.pipe(
    withAssign(() => ({
      form: formModel,
      resetFilters: formModel.resetFilters,
      applyFilters: formModel.applyFilters,
      period,
    })),
  )
}

export const trendingExploreFiltersAtom = reatomExploreFilters({
  name: 'trendingExploreFiltersAtom',
  period: EXPLORE_LIST_PERIOD_MAP[ExploreFeedType.Trending],
})

export const newExploreFiltersAtom = reatomExploreFilters({
  name: 'newExploreFiltersAtom',
  period: EXPLORE_LIST_PERIOD_MAP[ExploreFeedType.New],
})

export const topGainersExploreFiltersAtom = reatomExploreFilters({
  name: 'topGainersExploreFiltersAtom',
  period: EXPLORE_LIST_PERIOD_MAP[ExploreFeedType.TopGainers],
})

export const cookingExploreFiltersAtom = reatomExploreFilters({
  name: 'cookingExploreFiltersAtom',
  period: EXPLORE_LIST_PERIOD_MAP[ExploreFeedType.Cooking],
})

export const graduatedExploreFiltersAtom = reatomExploreFilters({
  name: 'graduatedExploreFiltersAtom',
  period: EXPLORE_LIST_PERIOD_MAP[ExploreFeedType.Graduated],
})

export const finalStretchExploreFiltersAtom = reatomExploreFilters({
  name: 'finalStretchExploreFiltersAtom',
  period: EXPLORE_LIST_PERIOD_MAP[ExploreFeedType.FinalStretch],
})

export const tableExploreFiltersAtom = reatomExploreFilters({
  name: 'tableExploreFiltersAtom',
  period: undefined,
})

export type ExploreFiltersAtom = ReturnType<typeof reatomExploreFilters>
